import script from "./BatchDeliveryDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BatchDeliveryDialog.vue?vue&type=script&lang=ts&setup=true"

import "./BatchDeliveryDialog.vue?vue&type=style&index=0&id=e50f614c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e50f614c"]])

export default __exports__